import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom, type PropsOf } from '@blaze-runtime/engine-domain';
import { getValueByPath } from '@blaze-shared/workflow-domain';
type QrCodeElement = CanvasElementFrom<'qrcode'>;
type QrCodeProps = PartialDeep<PropsOf<'qrcode'>>;

function transformTextInputToQrCode(source: CanvasElementFrom<'textInput'>): QrCodeElement {
  const props: PartialDeep<PropsOf<'textInput'>> = source.props || {};
  const newProps: QrCodeProps = {
    content: {
      url: {
        type: !getValueByPath(props, 'data.?key:value') ? 'add' : 'dynamic',
      },
    },
    style: {
      code: {
        foreground: props.style?.general?.title,
        background: props.style?.general?.accent,
      },
    },
  };

  // TODO: fix type
  return { props: newProps } as any;
}

export const transformToQrCode = {
  transformTextInputToQrCode,
};
